import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { db, firebase } from "@/firebase/firebaseConfig.js";
import moment from "moment-timezone";
import Vue from "vue";
const portMasterPilotMasterApi = AiseaApiFactory.get("portMasterPilotMaster");
const portMasterTugBoatMasterApi = AiseaApiFactory.get("portMasterTugBoatMaster");
const portMasterVehicleMasterApi = AiseaApiFactory.get("portMasterVehicleMaster");
const portMasterRopePickingBoatMasterApi = AiseaApiFactory.get("portMasterRopePickingBoatMaster");
const portMasterTeamLeaderMasterApi = AiseaApiFactory.get("portMasterTeamLeaderMaster");
const portMasterBerthMasterApi = AiseaApiFactory.get("portMasterBerthMaster");
const portMasterEnterpriseAgencyMasterApi = AiseaApiFactory.get("portMasterEnterpriseAgencyMaster");
const portMasterPortWharfApi = AiseaApiFactory.get("portMasterPortWharf");
const portMasterPortSelectApi = AiseaApiFactory.get("portMasterPortSelect");
const portMasterVesselMasterApi = AiseaApiFactory.get("portMasterVesselMaster");
const portMasterTasksApi = AiseaApiFactory.get("portMasterTasks");


export default {
  // タスクAPI
  async importTask(_, payload) {
    let res = await portMasterTasksApi.import(payload.portId, payload.file);
    Vue.$log.debug("importTask res.data", res.data);
    return res;
  },

  async setIsImportEdit({ commit }, payload) {
    commit("SET_IS_IMPORT_EDIT", payload);
  },

  async fetchSettings({ dispatch }, payload) {
    await dispatch('fetchMonitorsFromFirestore', payload);
    await dispatch('fetchMastersFromApi', payload);
    await dispatch('fetchColumnsFromFirestore', payload);
  },

  async subscribeDestinationWorkTasks({ state, commit, dispatch }, payload) {
    const enterprisePortPath = payload.hash
    const dateStr = payload.date
    let subscribeObj = await db
    .collection("pm_tasks").doc(enterprisePortPath).collection(dateStr)
    .onSnapshot(snapshot => {

      snapshot.docChanges().forEach(diff => {
        if (diff.type !== 'removed') {
          let payload = {
            date: dateStr,
            taskId: diff.doc.id,
            docData: diff.doc.data(),
          };
          dispatch("saveTaskWithName", payload);
        } else {
          let taskData = {
            date: state.selectedDateDisplay1,
            taskId: diff.doc.id,
          };
          commit("DELETE_DESTINATION_WORK_TASK", taskData);
          commit("SET_LAST_UPDATED_FOR_TASKS", Math.floor(moment().valueOf() / 1000 ));
        }
        let timeData = {
          date: dateStr,
          time: moment().format("YYYY/MM/DD HH:mm")
        };
        commit("SET_LAST_UPDATED_TIME_MAP", timeData);
      });
    });
    commit("ADD_FIRESTORE_SUBSCRIBE_LIST", subscribeObj);
  },

  async fetchDestinationWorkTasks({ dispatch }, payload) {
    const enterprisePortPath = payload.hash;
    const dateStr = payload.date

    const collectionRef1 = await db
      .collection("pm_tasks").doc(enterprisePortPath).collection(dateStr);
      collectionRef1.get().then((querySnapshot) => {
        querySnapshot.forEach(function(doc) {
          Vue.$log.debug(doc.id, " => ", doc.data());
          let payload = {
            date: dateStr,
            taskId: doc.id,
            docData: doc.data(),
            isImportedData: false
          };
          dispatch("saveTaskWithName", payload);
        })
      });

  },

  async saveImportedTasks({ state, commit, dispatch }, payload) {
    let tasksData = payload.tasksData
    let dataMap = tasksData.map(task => {
      const inputType = task.input_type
      let index = null
      const berthId = task.enterprise_port_berth_id
      index = state.masterMap.berth.findIndex(element => element.id == berthId)

      const vesselId = task.enterprise_port_vessel_id
      index = state.masterMap.vessels.findIndex(element => element.id == vesselId)
      const mmsi = state.masterMap.vessels[index].mmsi
      const callSign = state.masterMap.vessels[index].call_sign
      const imo = state.masterMap.vessels[index].imo

      const orderAt = moment(task.order_at.replace(/T/,' ').replace(/Z$/, '')).unix() // convert string to time

      index = state.masterMap.order_type.findIndex(element => String(element.value) === String(task.order_type))
      const orderTypeId = String(state.masterMap.order_type[index].id);

      const shippingAgencyId = task.enterprise_shipping_agency_id
      index = state.masterMap.shipping_agency.findIndex(element => element.id == shippingAgencyId)
      const previousPort = task.previous_port

      const headCountValue = task.head_count ? String(task.head_count).split('') : []
      const headCountColor = task.head_count ? headCountValue.map(() => -1) : []

      return {
        "berth#id": berthId,
        "order_at": {
          seconds: orderAt,
          nanoseconds: 0
        },
        "input_type": inputType,
        "order_type": orderTypeId,
        "shipping_agency#id": shippingAgencyId,
        "vessel#id": vesselId,
        "vessel#mmsi": mmsi,
        "vessel#call_sign": callSign,
        "vessel#imo": imo,
        "head_count#value": headCountValue,
        "head_count#color_id": headCountColor,
        "previous#port_name": previousPort,
        "progress_at": {}
      }
    })

    const dataMapObject = dataMap.reduce((result, current, index) => {
      result[index] = current;
      return result;
    }, {});

    let transactions = Object.keys(dataMapObject).map(taskId => {
      let payload = {
        taskId: taskId,
        docData: dataMapObject[taskId],
        isImportedData: true
      };
      return dispatch("saveTaskWithName", payload);
    })

    commit("DELETE_DESTINATION_WORK_IMPORTED_TASK")
    return Promise.all(transactions).then(res => {
      return res
    }).catch(error => {
      return error
    })
  },

  // stateのタスクレコード１件をAPIリクエスト用に変換する
  convertTaskForApi(_, task) {

    let pilotIdMap = {};
    if ( task.pilot.valueMap && task.pilot.valueMap.id ) {
      pilotIdMap[task.pilot.valueMap.id] = 3;
    } 
    let teamLeaderIdMap = {};
    if ( task.team_leader.valueMap && task.team_leader.valueMap.id ) {
      teamLeaderIdMap[task.team_leader.valueMap.id] = 3;
    }
    let tugBoatsCounts = null;
    if(task.tug_boats.valueMap.count) {
      tugBoatsCounts = Number(task.tug_boats.valueMap.count);
    }

    const obj = {
      "progress": task.progress.valueMap && !isNaN(task.progress.valueMap.id) ? String(task.progress.valueMap.id) : '1',  // 必須  default:'1'
      "order_at": task.order_at.valueMap.value && task.order_at.valueMap.value ? moment(task.order_at.valueMap.value).utc().toISOString() :null,
      "order_type": task.order_type.valueMap && !isNaN(task.order_type.valueMap.id) ? String(task.order_type.valueMap.id) : null, // 必須
      "progress_at": task.progress_at.valueMap && task.progress_at.valueMap.value && task.progress.valueMap && task.progress_at.valueMap.value[String(task.progress.valueMap.id)]
              ? moment(task.progress_at.valueMap.value[String(task.progress.valueMap.id)].seconds * 1000).utc().toISOString()
              : null,
      "previous_port_name": task.previous.valueMap.port_name ? task.previous.valueMap.port_name : null,
      "berth_id": task.berth.valueMap ? task.berth.valueMap.id : null, // 必須？
      "head_count_value": task.head_count.valueMap.value ? task.head_count.valueMap.value : [],
      "head_count_color_id": task.head_count.valueMap.color_id ? task.head_count.valueMap.color_id : [],
      "vessel_id": task.vessel.valueMap.enterprisePortVessel ? task.vessel.valueMap.enterprisePortVessel.id : null, // 必須？
      "task_name": task.vessel.valueMap.task_name ? task.vessel.valueMap.task_name : null,
      "flag": task.flag.valueMap.value ? task.flag.valueMap.value : null,
      "bit_left": task.bit.valueMap.left ? task.bit.valueMap.left : null,
      "bit_left_options": task.bit.valueMap.left_options ? task.bit.valueMap.left_options : null,
      "bit_right": task.bit.valueMap.right ? task.bit.valueMap.right : null,
      "bit_right_options": task.bit.valueMap.right_options ? task.bit.valueMap.right_options : null,
      "boardside_type": task.boardside_type.valueMap && !isNaN(task.boardside_type.valueMap.id) ? Number(task.boardside_type.valueMap.id) : null,
      "pilot_ids": pilotIdMap,
      "team_leader_ids": teamLeaderIdMap,
      
      "rope_boat_ids": task.rope_boats.valueMap.value ? task.rope_boats.valueMap.value.reduce((result, current) => {
        result[String(current.id)] = current.status;
        return result;
      }, {}) : {},
      "vehicle_ids": task.vehicles.valueMap.value ? task.vehicles.valueMap.value.reduce((result, current) => {
        result[String(current.id)] = current.status;
        return result;
      }, {}) : {},
      "tug_boat_counts": tugBoatsCounts,
      "tug_boat_ids": task.tug_boats.valueMap.value ? task.tug_boats.valueMap.value.reduce((result, current) => {
        result[String(current.id)] = current.status;
        return result;
      }, {}) : {},
      "weather_id": task.weather.valueMap ? task.weather.valueMap.id : null,
      "shipping_agency_id": task.shipping_agency.valueMap && task.shipping_agency.valueMap.id ? task.shipping_agency.valueMap.id : null,

      "required_note" : task.required_note.valueMap ? task.required_note.valueMap.value : null, // TODO: 要対応
      "input_type" : task.input_type && task.input_type.valueMap ? task.input_type.valueMap.value : null, // TODO: 要対応
    }

    Vue.$log.debug("task = ", JSON.stringify(obj));
    return obj;
  },

  // Firestoreへ一括保存
  async saveTasksToFirestore({ commit, dispatch }, payload) {

    const taskPromiseList = Object.entries(payload.tasksData).map(([, task]) => {
      return dispatch("convertTaskForApi", task);
    })

    await Promise.all(taskPromiseList).then(async ( taskList ) => {
      Vue.$log.debug("taskList", taskList);
      taskList.forEach((task, index) => {
        task.sort_order = index;
      });

      await portMasterTasksApi.bulks(payload.enterprisePort.id ,{ tasks: taskList }).then(res => {
        if ( !res || !res.status ) {
          throw res
        } else {
          commit("DELETE_DESTINATION_WORK_IMPORTED_TASK")
          return res.data
        }
      });

    });
  },

  async importDestinationWorkTasks({ dispatch }, payload) {
    await dispatch('fetchMastersFromApi', payload.selectedPort);
    await dispatch('saveImportedTasks', payload);
  },


  // // 整形＋マスタ名を足す処理を追加
  attachNameToDocData({ state }, payload) {

    const enterprisePortVessel = state.masterMap.vessels.find(x => x.id === payload.docData['vessel#id']);

    // // 整形＋マスタ名を足す処理を追加
    let taskDataWithName = {
      docData:          payload.docData, // マスタ名更新などで、再展開するために、元データは保持しておく。
      order_type:       { valueMap: state.masterMap.order_type.find(x => String(x.id) === String(payload.docData.order_type)), },
      input_type:       { valueMap: { value:(payload.docData.input_type) } },
      order_at:         { valueMap: { value:(payload.docData.order_at ? payload.docData.order_at.seconds * 1000: null), date: payload.date, } , },
      progress:         { valueMap: state.masterMap.progress.find(x => String(x.id) == String(payload.docData.progress)), },
      progress_at:      { valueMap: { value: payload.docData.progress_at , date: payload.date, progress: String(payload.docData.progress) } , }, 
      previous:         { valueMap: { port_name: payload.docData['previous#port_name'], berth: state.masterMap.berth.find(x => x.id === payload.docData['previous#berth_id']), order_type: String(payload.docData.order_type),  },}, // TODO: 要検証
      berth:            { valueMap: state.masterMap.berth.find(x => x.id === payload.docData['berth#id']), },
      vessel:           { valueMap: { enterprisePortVessel: enterprisePortVessel, task_name: payload.docData['task#name'], order_type: String(payload.docData.order_type), mmsi: payload.docData['vessel#mmsi'] , imo: payload.docData['vessel#imo'], call_sign: payload.docData['vessel#call_sign'], }, },
      head_count:       { valueMap: { value: payload.docData['head_count#value'], color_id:payload.docData['head_count#color_id'], options:payload.docData['head_count#options']  }, },
      bit:              { valueMap: { left: payload.docData['bit#left'], left_options:  payload.docData['bit#left_options'], right:  payload.docData['bit#right'], right_options:  payload.docData['bit#right_options']}, },
      flag:             { valueMap: { value: payload.docData.flag}, },
      boardside_type:   { valueMap: state.masterMap.boardside_type.find(x => x.id === payload.docData.boardside_type) },
      shipping_agency:  { valueMap: state.masterMap.shipping_agency.find(x => x.id === payload.docData['shipping_agency#id']) },
      caution_note:     { valueMap: { value: enterprisePortVessel ? enterprisePortVessel.tags : null }, },
      required_note:    { valueMap: { value: payload.docData.required_note}, },
      sort_order:       { valueMap: { value: payload.docData.sort_order, order_at_string: payload.docData.order_at ? moment(payload.docData.order_at.seconds * 1000).local().format('HH:mm') : '--:--', enterprisePortVessel: enterprisePortVessel}, },
      weather:          { valueMap: state.masterMap.weather.find(x => x.id === payload.docData['weather#id'] ),  },
      pilot:            { valueMap: ( payload.docData['pilot#id'  ] ? Object.keys(payload.docData['pilot#id'  ]).filter(pilotId => state.masterMap['pilot'  ].find(x => x.id === pilotId))
                                                                                                                .map(pilotId => { let a = JSON.parse(JSON.stringify(state.masterMap['pilot'  ].find(x => x.id === pilotId)));  a.status = payload.docData['pilot#id'  ][pilotId]; return a;}).find(x => x) : null),  },
      team_leader:      { valueMap: ( payload.docData['team_leader#id'  ] ? Object.keys(payload.docData['team_leader#id'  ]).filter(pilotId => state.masterMap['team_leader'  ].find(x => x.id === pilotId))
                                                                                                                            .map(pilotId => { let a = JSON.parse(JSON.stringify(state.masterMap['team_leader'  ].find(x => x.id === pilotId)));  a.status = payload.docData['team_leader#id'  ][pilotId]; return a;}).find(x => x) : null),  },
      vehicles:         { valueMap: {
                            value:    ( payload.docData['vehicles#id'  ] ? Object.keys(payload.docData['vehicles#id'  ]).filter(equipmentId => state.masterMap['vehicles'  ].find(x => x.id === equipmentId))
                                                                                                                        .map(equipmentId => { let a = JSON.parse(JSON.stringify(state.masterMap['vehicles'  ].find(x => x.id === equipmentId)));  a.status = payload.docData['vehicles#id'  ][equipmentId]; return a;}) : []),
                            is_size:  state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'vehicles'  ) ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'vehicles'  ).is_size  : false,
                            is_count: state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'vehicles'  ) ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'vehicles'  ).is_count : false,
                            count:    payload.docData['vehicles#count'  ],
                        }},
      tug_boats:        { valueMap: {
                            value:    ( payload.docData['tug_boats#id' ] ? Object.keys(payload.docData['tug_boats#id' ]).filter(equipmentId => state.masterMap['tug_boats' ].find(x => x.id === equipmentId))
                                                                                                                        .map(equipmentId => { let a = JSON.parse(JSON.stringify(state.masterMap['tug_boats' ].find(x => x.id === equipmentId)));  a.status = payload.docData['tug_boats#id' ][equipmentId]; return a;}) : []),
                            is_size:  state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'tug_boats' ) ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'tug_boats' ).is_size  : false,
                            is_count: state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'tug_boats' ) ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'tug_boats' ).is_count : false,
                            count:    payload.docData['tug_boats#count' ],
                        }},
      rope_boats:       { valueMap: {
                            value:    ( payload.docData['rope_boats#id'] ? Object.keys(payload.docData['rope_boats#id']).filter(equipmentId => state.masterMap['rope_boats'].find(x => x.id === equipmentId))
                                                                                                                        .map(equipmentId => { let a = JSON.parse(JSON.stringify(state.masterMap['rope_boats'].find(x => x.id === equipmentId)));  a.status = payload.docData['rope_boats#id'][equipmentId]; return a;}) : []),
                            is_size:  state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'rope_boats') ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'rope_boats').is_size  : false,
                            is_count: state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'rope_boats') ? state.destinationWorkHeaders.find(equipment => equipment.columnKey === 'rope_boats').is_count : false,
                            count:    payload.docData['rope_boats#count'],
                        }},
    };

    for (let key of Object.keys(taskDataWithName)) {
      if ( key !== 'docData' ) {
        taskDataWithName[key]['taskId'] = payload.taskId;
        taskDataWithName[key]['columnKey'] = key;
        taskDataWithName[key]['changes'] = payload.docData.changes && payload.docData.changes[key] ? payload.docData.changes[key].seconds * 1000 : null ;
      }
    }
    return taskDataWithName;
  },
  async saveTaskWithName({ dispatch, commit }, payload) {

    const taskDataWithName = await dispatch("attachNameToDocData", payload);

    // steteに保存.
    // 保存＆呼び出しを速くするため、state.destinationWorkTasksMap[payload.date][payload.taskId] の連想配列型で保存.
    let taskData = {
      date: payload.date,
      taskId: payload.taskId,
      destinationWorkTask: taskDataWithName,
    };
    if (payload.isImportedData) {
      commit("SET_DESTINATION_WORK_IMPORTED_TASK", taskData);
    } else if (payload.isInsertOneMode) {
      commit("SET_DESTINATION_WORK_ONE_TASK", taskData.destinationWorkTask);
    } else {
      commit("SET_DESTINATION_WORK_TASK", taskData);
    }
    commit("SET_LAST_UPDATED_FOR_TASKS", Math.floor(moment().valueOf() / 1000 ));
  },

  // 1件新規登録開始時に空のレコードを一つ作る。
  async setBlankTask({ commit, dispatch }, payload) {

    const taskId = Math.random().toString(36).slice(-10) + Math.random().toString(36).slice(-10); // ID値を生成。２０文字の乱数文字列(0-9a-z)
    let insertOneBlankData = {
      date: payload.date,
      taskId: taskId,
      docData: {},
      isInsertOneMode: true
    };

    commit("SET_SELECTED_CELL", { taskId: taskId, columnKey: payload.initColumnKey });
    await dispatch("saveTaskWithName", insertOneBlankData);
  },

  // Firestore subscribe データ更新イベント通知を受けて、各種更新データのFetch依頼
  async subscribeEventUpdate({ commit, dispatch, state }, payload){

    const enterprisePortPath = payload.hash;

    let subscribeObj = await db
    .collection("pm_settings").doc(enterprisePortPath).collection("events")
    .onSnapshot(snapshot => {

      snapshot.docChanges().forEach(diff => {
        Vue.$log.debug("diff.doc", diff.doc.id, diff.doc.data().timestamp.seconds, Math.floor( moment().valueOf() / 1000 ));

        if ( diff.doc.id === 'columns' ) {
          if ( diff.doc.data().timestamp.seconds > state.lastUpdatedForColumns ) {
            dispatch('fetchColumnsFromFirestore', payload);
          }
        } else if ( diff.doc.id === 'monitors' ) {
          if ( diff.doc.data().timestamp.seconds > state.lastUpdatedForMonitors ) {
            dispatch('fetchMonitorsFromFirestore', payload);
          }
        } else if ( diff.doc.id === 'datas' ) {
          if ( diff.doc.data().timestamp.seconds > state.lastUpdatedForMasters ) {
            Vue.$log.debug("master updated.");
            dispatch('fetchMastersFromApi', payload);
          }
        }
      });
    });
    commit("ADD_FIRESTORE_SUBSCRIBE_LIST", subscribeObj);
  },



  /**
   * 各種マスタ情報の一括取得(API,Firestore).
   *
   * @param {*} payload
   */
  async fetchMastersFromApi({ commit, dispatch, state }, payload){

    let promiseAll = [];

    promiseAll.push(new Promise(( resolve ) => {
      portMasterPortWharfApi.fetch(payload.id).then((resWharfs) => {
      let wharfsMasterList = {
        masterName: 'wharfs',
        masterList: resWharfs.data.wharfs,
      };
      commit("SET_MASTER_MAP", wharfsMasterList);
      resolve('wharfs');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterBerthMasterApi.fetch(payload.id).then((resBerth) => {
      let berthMasterList = {
        masterName: 'berth',
        masterList: resBerth.data.berths,
      };
      commit("SET_MASTER_MAP", berthMasterList);
      resolve('berth');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterTeamLeaderMasterApi.fetch(payload.id).then((resTeamLeader) => {
      let teamLeaderMasterList = {
        masterName: 'team_leader',
        masterList: resTeamLeader.data.team_leaders,
      };
      commit("SET_MASTER_MAP", teamLeaderMasterList);
      resolve('team_leader');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterEnterpriseAgencyMasterApi.fetch(payload.id).then((resShippingAgency) => {
      let shippingAgencyMasterList = {
        masterName: 'shipping_agency',
        masterList: resShippingAgency.data.shipping_agencies,
      };
      commit("SET_MASTER_MAP", shippingAgencyMasterList);
      resolve('shipping_agency');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterVesselMasterApi.fetch(payload.id).then((resVessels) => {
      let vesselMasterList = {
        masterName: 'vessels',
        masterList: resVessels.data.vessels,
      };
      commit("SET_MASTER_MAP", vesselMasterList);
      resolve('vessels');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterPilotMasterApi.fetch(payload.id).then((resPilot) => {
      let pilotMasterList = {
        masterName: 'pilot',
        masterList: resPilot.data.pilots,
      };
      commit("SET_MASTER_MAP", pilotMasterList);
      resolve('pilot');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterTugBoatMasterApi.fetch(payload.id).then((resTugBoats) => {
      let tugBoatsMasterList = {
        masterName: 'tug_boats',
        masterList: resTugBoats.data.tug_boats,
      };
      commit("SET_MASTER_MAP", tugBoatsMasterList);
      resolve('tug_boats');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterRopePickingBoatMasterApi.fetch(payload.id).then((resRopeBoats) => {
      let ropeBoatsMasterList = {
        masterName: 'rope_boats',
        masterList: resRopeBoats.data.rope_picking_boats,
      };
      commit("SET_MASTER_MAP", ropeBoatsMasterList);
      resolve('rope_boats');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterVehicleMasterApi.fetch(payload.id).then((resVehicles) => {
      let vehiclesMasterList = {
        masterName: 'vehicles',
        masterList: resVehicles.data.vehicles,
      };
      commit("SET_MASTER_MAP", vehiclesMasterList);
      resolve('vehicles');
    });
  }));
  promiseAll.push(new Promise(( resolve ) => {
    portMasterPortSelectApi.fetch().then((resPorts) => {
      let portsMasterList = {
        masterName: 'ports',
        masterList: resPorts.data.ports,
      };
      commit("SET_MASTER_MAP", portsMasterList);
      resolve('ports');
    });
  }));
  promiseAll.push(new Promise( ( resolve ) => {
    let boardsideTypeMasterList = {
      masterName: 'boardside_type',
      masterList: [
        { id:1, name:"左", },
        { id:2, name:"右", },
        { id:3, name:"左○", },
        { id:4, name:"右○", },
        { id:5, name:"？", },
      ],
    };
    commit("SET_MASTER_MAP", boardsideTypeMasterList);

    let pilotKanaMasterList = {
      masterName: 'pilot_kana',
      masterList: [
        { id:1, value:"あ", candidate: "あいうえおアイウエオ", },
        { id:2, value:"か", candidate: "かきくけこカキクケコ", },
        { id:3, value:"さ", candidate: "さしすせそサシスセソ", },
        { id:4, value:"た", candidate: "たちつてとタチツテト", },
        { id:4, value:"な", candidate: "なにぬねのナニヌネノ", },
        { id:4, value:"は", candidate: "はひふへほハヒフヘホ", },
        { id:4, value:"ま", candidate: "まみむめもマミムメモ", },
        { id:4, value:"や", candidate: "やゆよヤユヨ", },
        { id:4, value:"ら", candidate: "らりるれろラリルレロ", },
        { id:4, value:"わ", candidate: "わをんワヲン", },
      ],
    };
    commit("SET_MASTER_MAP", pilotKanaMasterList);
    resolve('localConstant');

  }));


    // FireStoreコンスタントもSET_MASTER_MAPする。
    const enterprisePortPath = payload.hash;
    const collectionRef = db
      .collection("pm_settings").doc(enterprisePortPath).collection("constants");
    const snapshot = await collectionRef.get();
    snapshot.forEach(doc => {

      let constantData = {
        masterName: doc.id,
        masterList: [],
      };

      if ( doc.data().values && Array.isArray(doc.data().values)  ) {
        constantData.masterList = doc.data().values.map((data, index) => { return { id: index, value: data}; });
      } else if ( (typeof doc.data().values === 'object' && doc.data().values !== null ) ) {
        constantData.masterList = Object.keys(doc.data().values).map(key => { return { id: key, value: doc.data().values[key]}; });
      } else {
        constantData.masterList = Object.keys(doc.data()).map(key => { return { id: key, value: doc.data()[key]}; });
      }

      commit("SET_MASTER_MAP", constantData);

      if ( ['head_count', 'progress'].includes(doc.id) ) {
        let constantColors = {
          masterName: doc.id + '_colors',
          masterList: [],
        };
        if ( doc.data().colors && Array.isArray(doc.data().colors)  ) {
          constantColors.masterList = doc.data().colors.map((data, index) => { return { id: index, value: data}; });
        } else if ( (typeof doc.data().colors === 'object' && doc.data().colors !== null ) ) {
          constantColors.masterList = Object.keys(doc.data().colors).map(key => { return { id: key, value: doc.data().colors[key]}; });
        }
        commit("SET_MASTER_MAP", constantColors);
      }

      if ( doc.id === 'order_type' ) {
        let constantOrderTypeSorts = {
          masterName: doc.id + '_sorts',
          masterList: [],
        };
        if ( doc.data().sorts && Array.isArray(doc.data().sorts)  ) {
          constantOrderTypeSorts.masterList = doc.data().sorts.map((data, index) => { return { id: index, value: String(data)}; });
        }
        commit("SET_MASTER_MAP", constantOrderTypeSorts);
      }
    });

    await Promise.all(promiseAll);

    Vue.$log.debug("masterMap",state.masterMap);

    // マスタ情報が更新されたので、タスク情報にマスタ名を再び付与. 
    // 予定表
    Object.entries(state.destinationWorkTasksMap).forEach(([targetDate,taskMapByDate]) => {
      Object.keys(taskMapByDate).forEach(taskId => {
          let taskData = {
            enterprisePortId: payload.id,
            date: targetDate,
            taskId: taskId,
            docData: taskMapByDate[taskId].docData, // docData = Firestore取得直後に保存していた生データ。
          };
          dispatch("saveTaskWithName", taskData);
        });
    });

    // マスタ情報が更新されたので、タスク情報にマスタ名を再び付与. 
    // インポート後
    Object.entries(state.destinationWorkImportedTasksMap).forEach(([taskId,taskMapByDate]) => {
      let taskData = {
        enterprisePortId: payload.id,
        date: null,
        taskId: taskId,
        docData: taskMapByDate.docData, 
        isImportedData: true,
      };
      console.debug("imported taskData", taskData);
      dispatch("saveTaskWithName", taskData);
    });

    // マスタ情報が更新されたので、タスク情報にマスタ名を再び付与. 
    // １件新規登録
    state.destinationWorkOneTask.forEach(taskMap => {
      const taskId = Object.values(taskMap).find(x => x.taskId).taskId;
      let taskData = {
        enterprisePortId: payload.id,
        date: state.selectedDateDisplay1 ,
        taskId: taskId,
        docData: taskMap.docData,
        isInsertOneMode: true,
      };
      dispatch("saveTaskWithName", taskData);
    });

    commit("SET_LAST_UPDATED_FOR_MASTERS", Math.floor(moment().valueOf() / 1000));
  },


  // Firestore ディスプレイ設定を取得
  async fetchMonitorsFromFirestore({ commit }, payload){

    const enterprisePortPath = payload.hash;

    const collectionRef = db
    .collection("pm_settings").doc(enterprisePortPath).collection("monitors");

    const snapshot = await collectionRef.get();
    snapshot.forEach(doc => {
      let payload = {
        id: doc.id,
        setting: doc.data(),
      };
      commit("SET_MONITOR_SETTING_MAP", payload);

    });

    commit("SET_LAST_UPDATED_FOR_MONITORS", Math.floor(moment().valueOf() / 1000));

  },

  // Firestore subscribe 表示設定を取得
  async fetchColumnsFromFirestore({ commit }, payload){

    const enterprisePortPath = payload.hash;

    const collectionRef = db
    .collection("pm_settings").doc(enterprisePortPath).collection("columns");

    const snapshot = await collectionRef.get();
    let columnDataMap = {};
    snapshot.forEach(doc => {
      columnDataMap[doc.id] = doc.data();
    });

    let destinationWorkHeaders = [];
    for ( let columnKey  of Object.keys(columnDataMap) ){
      let destinationWorkHeader = columnDataMap[columnKey];
      destinationWorkHeader['columnKey'] = columnKey;
      destinationWorkHeaders.push(destinationWorkHeader);
    }

    destinationWorkHeaders.sort((a, b) => {
      // sortでソート
      let comparison = 0;
      if (a.sort > b.sort) {
        comparison = 1;
      } else if (a.sort < b.sort) {
        comparison = -1;
      }
      return comparison ;
    });

    commit("SET_DESTINATION_WORK_HEADERS",destinationWorkHeaders);
    commit("SET_LAST_UPDATED_FOR_COLUMNS", Math.floor(moment().valueOf() / 1000));
  },

  // Firestore 項目順序を更新
  async updateColumnOrder(payload) {
    const enterprisePortPath = payload.enterprisePort.hash;

    let batch = db.batch()
    payload.sortOrders.forEach(element => {
      let ref = db.collection("pm_settings").doc(enterprisePortPath)
      .collection("columns").doc(element.columnKey);
      batch.update(ref, {sort: element.sort_order})
    })
    batch.commit().then(() => {
      Vue.$log.debug('update succeed')
    }).catch(err => {
      Vue.$log.error("Error update Document", err);
    })

  },

  // destinationWorkTaskの該当のタスクを消す
  async deleteDestinationWorkOneTask({ state }, payload){
    const enterprisePortPath = payload.selectedPort.hash
    const date = state.selectedDateDisplay1
    const taskId = payload.id

    const collectionRef1 = await db
    .collection("pm_tasks").doc(enterprisePortPath).collection(date).doc(taskId);
    collectionRef1.delete().then(() => {
      Vue.$log.debug("Document successfully deleted!");
    }).catch((error) => {
      Vue.$log.error("Error removing document: ", error);
    });
  },

  async deleteAllDestinationWorkTask({commit}) {
    commit("DELETE_ALL_DESTINATION_WORK_TASK")
  },
  // destinationWorkImportedTaskの該当のタスクを消す
  async deleteDestinationWorkImportedOneTask({ commit }, payload){
    commit("DELETE_DESTINATION_WORK_IMPORTED_ONE_TASK", payload)
    commit("SET_LAST_UPDATED_FOR_TASKS", Math.floor(moment().valueOf() / 1000 ));
  },

  // Firestore 入出港予定表を取得
  async fetchOrderList(_, payload){

    const enterprisePortPath = payload.hash;
    let tasks = []

    let today = moment(new Date()).format('YYYYMMDD')

    const collectionRef1 = await db
    .collection("pm_tasks").doc(enterprisePortPath).collection(today);
    collectionRef1.get().then((querySnapshot) => {
      tasks.push({
        date: today,
        orderCount: querySnapshot.size,
        draft: false
      })
    });

    let dateArray = []
    for (let index = -1; index < 5; index++) {
        dateArray.push(moment(new Date()).add(index,'days').format('YYYYMMDD'))
    }

    let refs = dateArray.map(element => {
      let ref = db.collection("pm_tasks").doc(enterprisePortPath).collection(element).get()
      ref.date = element
      return ref
    })
    return Promise.all(refs).then(docs => {
      let filteredDocs = docs.filter(doc => doc.size != 0)
      let res = filteredDocs.map(doc => {
        return {
          date: doc.docs[0].ref.parent.id,
          orderCount: doc.size
        }
      })
      return res
    }).catch(error => {
      return error
    })
  },

  async updateFirestoreDocument({ state, dispatch }, payload) {
    const enterprisePortPath = payload.enterprisePort.hash;
    const updateMode = payload.updateMode !== undefined ? payload.updateMode : false;
    const updateTimeStamp = payload.updateTimeStamp !== undefined ? payload.updateTimeStamp : false;
    let changeTimestamp = {}
    changeTimestamp.changes = {};
    for (let key of Object.keys(payload.data) ) {
      if (key !== 'changes'){
        let columnKey = key.replace(/#.*$/i, '');

        if (columnKey == "task") columnKey = "vessel"
        changeTimestamp.changes[columnKey] = updateTimeStamp ? new Date(moment().toISOString()) : firebase.firestore.FieldValue.delete();
      }
    }
    let diaplayYmd = state.selectedDateDisplay1;
    let orderAtYmd = payload.data['order_at'] ? await dispatch( "getOrderYmd", { targetYmd: diaplayYmd, newDate: payload.data['order_at'] }) : null;
    if ( ! orderAtYmd || diaplayYmd === orderAtYmd ) {
      const docRef = db
        .collection("pm_tasks").doc(enterprisePortPath).collection(state.selectedDateDisplay1)
        .doc(payload.taskId);
      if ( payload.data['sort_order'] !== undefined ) {
        docRef.set(payload.data, { merge: true });
      } else if ( updateMode ) {      
        docRef.update(payload.data);
        docRef.set(changeTimestamp, { merge: true });
      } else {
        docRef.set(Object.assign({}, payload.data, changeTimestamp), { merge: true });
      }
    } else {
      // オーダー時間の変更が表示日付を超えた場合。

      // insert
      if (updateTimeStamp) {
        db
          .collection("pm_tasks").doc(enterprisePortPath).collection(orderAtYmd)
          .doc(payload.taskId)
          .set(Object.assign({}, state.destinationWorkTasksMap[diaplayYmd][payload.taskId].docData, payload.data, changeTimestamp));
      } else {
        db
          .collection("pm_tasks").doc(enterprisePortPath).collection(orderAtYmd)
          .doc(payload.taskId)
          .set(Object.assign({}, state.destinationWorkTasksMap[diaplayYmd][payload.taskId].docData, payload.data));
        db
          .collection("pm_tasks").doc(enterprisePortPath).collection(orderAtYmd)
          .doc(payload.taskId)
          .set(changeTimestamp, { merge: true });
      }

      // remove
      db
        .collection("pm_tasks").doc(enterprisePortPath).collection(diaplayYmd)
        .doc(payload.taskId)
        .delete();
    }
  },

  /**
   * 修正後のオーダー時間から、表示対象日を算出する。（tasks.hour_intervalを考慮）
   * 
   * payload.targetYmd: 表示対象日（文字列型：YYYYMMDD）
   * payload.newDate: 修正後オーダー日時（Date型）
   * 
   */
  getOrderYmd({ state }, payload) {
    const hourIntervalObj = state.masterMap['tasks'].find(x => x.id === 'hour_interval');
    const hourInterval = hourIntervalObj ? hourIntervalObj.value : "00:00";
    if ( payload.targetYmd && payload.newDate) {
      let hourIntervalTimeStr = `${payload.targetYmd.slice(0,4)}-${payload.targetYmd.slice(4,6)}-${payload.targetYmd.slice(6,8)}T${hourInterval}:00`;
      for ( let i = -30 ; i < 30 ; i++  ) {
        if ( moment(payload.newDate).valueOf() >= moment(hourIntervalTimeStr).add( i, 'days').valueOf() 
          && moment(payload.newDate).valueOf() < moment(hourIntervalTimeStr).add( i + 1, 'days').valueOf() ) {
          return moment(hourIntervalTimeStr).add( i, 'days').format('YYYYMMDD');
        }
      }
    }
    return null;  
  },

  // fireStoreに投げずにstateだけ更新
  updateDestinationWorkTask({ state, dispatch }, payload) {
    let diffDataMap = payload.data;
    let isImportedData = payload.isImportedData;
    let isInsertOneMode = payload.isInsertOneMode;
    let docData = {}

    let selectedDate = ""

    if (isImportedData) {
      docData = JSON.parse(JSON.stringify(state.destinationWorkImportedTasksMap[payload.taskId].docData));
    } else if ( isInsertOneMode ) {
      selectedDate = payload.targetDate;
      docData = state.destinationWorkOneTask.length > 0 && state.destinationWorkOneTask[0].docData ? JSON.parse(JSON.stringify(state.destinationWorkOneTask[0].docData)) : {};
    } else {
      selectedDate = state.selectedDateDisplay1;
      docData = JSON.parse(JSON.stringify(state.destinationWorkTasksMap[state.selectedDateDisplay1][payload.taskId].docData));
    }

    for ( let columnKey  of Object.keys(diffDataMap) ){

      if ( columnKey !== 'order_at' &&  columnKey !== 'progress_at' ) {
        docData[columnKey] = diffDataMap[columnKey];

      } else if (columnKey === 'order_at') {
        docData[columnKey] = !diffDataMap[columnKey] ? null : {
          seconds: Math.floor(diffDataMap[columnKey].getTime() / 1000),
          nanoseconds: 0,
        }

      } else if (columnKey === 'progress_at') {
        const progress = String(docData['progress']);
        if ( !docData[columnKey] ) {
          docData[columnKey] = {};
        }
        docData[columnKey][progress] = !diffDataMap[columnKey] || !diffDataMap[columnKey][progress] ? null : {
          seconds: Math.floor(diffDataMap[columnKey][progress].getTime() / 1000),
          nanoseconds: 0,
        }
      }
    }

    let updatePayload = {
      date: selectedDate,
      taskId: payload.taskId,
      docData: docData,
      isImportedData: isImportedData,
      isInsertOneMode: isInsertOneMode,
    };

    dispatch("saveTaskWithName", updatePayload);
  },


  // fireStoreにもstateにも投げずにag-grid-vueだけ更新
  async mergeUpdateDataIntoTaskRecord({ state, dispatch }, updateData) {
    //let diffDataMap = payload.data;
    let isImportedData = updateData.isImportedData;
    let isInsertOneMode = updateData.isInsertOneMode;
    let stateTaskDocData = {}

    let selectedDate = ""

    // // stateからタスク1行の生データを取得
    // let stateTaskDocData =  state.destinationWorkTasksMap[state.displayDates[state.selectedDateDisplay1]][updateData.taskId].docData;
    if (isImportedData) {
      stateTaskDocData = JSON.parse(JSON.stringify(state.destinationWorkImportedTasksMap[updateData.taskId].docData));
    } else if ( isInsertOneMode ) {
      selectedDate = updateData.targetDate;
      stateTaskDocData = state.destinationWorkOneTask.length > 0 && state.destinationWorkOneTask[0].docData ? JSON.parse(JSON.stringify(state.destinationWorkOneTask[0].docData)) : {};
    } else {
      selectedDate = state.selectedDateDisplay1;
      stateTaskDocData = JSON.parse(JSON.stringify(state.destinationWorkTasksMap[state.selectedDateDisplay1][updateData.taskId].docData));
    }


    // updateDataをマージして、新しいタスク行を生成。
    // const mergedChanges = Object.assign({}, stateTaskDocData.changes, changeTimestamp.changes);
    const newStateTaskDocData = Object.assign({},stateTaskDocData, updateData.data);

    // 日付データは、Date型 → FireStoreTimestamp型に変換してから、新しいタスク行に再上書き。
    for ( let columnKey  of Object.keys(updateData.data) ){

      if (columnKey === 'order_at') {
        newStateTaskDocData[columnKey] = !updateData.data[columnKey] ? null : {
          seconds: Math.floor(updateData.data[columnKey].getTime() / 1000),
          nanoseconds: 0,
        }

      } else if (columnKey === 'progress_at') {
        const progress = String(newStateTaskDocData['progress']);
        if ( !newStateTaskDocData[columnKey] ) {
          newStateTaskDocData[columnKey] = {};  
        }
        newStateTaskDocData[columnKey][progress] = !updateData.data[columnKey] || !updateData.data[columnKey][progress] ? null : {
          seconds: Math.floor(updateData.data[columnKey][progress].getTime() / 1000),
          nanoseconds: 0,
        }
      }
    }
    // idだけのデータにマスタデータの名前を付与。
    let newTaskData = {
      enterprisePortId: updateData.enterprisePort.id,
      date: selectedDate,
      taskId: updateData.taskId,
      docData: newStateTaskDocData,
      isImportedData: isImportedData,
      isInsertOneMode: isInsertOneMode,
    };
    const newTaskWithName = await dispatch("attachNameToDocData", newTaskData);

    return newTaskWithName;
  },

  // 一件新規追加での保存処理。
  async submitDestinationWorkOneTask ({ state, dispatch }, payload) {

    const task = state.destinationWorkOneTask[0];
    const taskForApi = await dispatch("convertTaskForApi", task);

    Vue.$log.debug("taskForApi",taskForApi);

    // 一覧の追加箇所は一覧上部。sort_order=0をセットして、あとは第１オーダー=sort_order,第２オーダー=order_atの一覧表示条件に任せる。
    taskForApi.sort_order = 0;

    await portMasterTasksApi.add(payload.enterprisePort.id, taskForApi).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    });
  },


  setSelectedDateDisplay1({ commit }, payload) {
    commit("SET_SELECTED_DATE_DISPLAY1", payload);
  },

  setVesselNameJapaneseFlg({ commit }, payload){
    commit("SET_VESSEL_NAME_JAPANESE_FLG", payload);
  },

  setSelectedCell({ commit }, payload) {
    commit("SET_SELECTED_CELL", payload);
  },

  setSummaryDialogShowPopup({ commit }, payload) {
    commit("SET_SUMMARY_DIALOG_SHOW_POPUP", payload);
  },

  // unsubscribe
  async unsubscribeFirestore({ commit }) {
    commit("UNSUBSCRIBE_FIRESTORE");
  },
}
